import React from 'react';
import HighlightedLink from './HighlightedLink';
import { NavbarProps } from './Navbar';

const DesktopNavbar = (props: NavbarProps) => {
  return (
    <nav className='flex bg-white text-xl text-coffee fixed w-full p-4 z-10'>
      <div className='flex flex-row flex-grow-0'>
        <img src={process.env.PUBLIC_URL + '/favicon.ico'} className='transform w-8 h-8 mx-4' />
        <p className='mx-4 font-raleway font-bold'>Youth Passion Project</p>
      </div>
      <ul className='flex flex-row flex-grow flex-nowrap justify-end'>
        {props.links.map((link, i) => (
          <li key={i}>
            <HighlightedLink to={link.to} text={link.text ?? ''}></HighlightedLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default DesktopNavbar;
